import { toast } from "react-toastify";
import { useEffect, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FullScreenLoader, PageTitle } from "components";
import { useGetAPieceOfPointOfSaleQuery, useUpdatePointOfSaleMutation } from "redux/api/pointOfSaleApi";
import { PointOfSale } from "components/PointOfSale";
import {  useGetAllCompaniesQuery } from "redux/api/companyApi";
import { ICompany } from "Models/Company";
import { ISelectOption } from "Interfaces/Utils";
import { useGetAllProvincesQuery } from "redux/api/provinceApi";
import { useIntl } from "react-intl";

// Static vars

const RETURN_PAGE = "/point-of-sale";

/**
 * Component to render news edit view
*/

export const PointOfSaleEditPage = () => {
  const { formatMessage } = useIntl();
  const PAGE_TITLE = formatMessage({ id: "pointOfSale.editTitle" });
  const RETURN_LABEL = formatMessage({ id: "pointOfSale.back" });
  const UPDATE_SUCCESS = formatMessage({ id: "pointOfSale.updatedSuccessfuly" });
  const { pointOfSaleId } = useParams();

  const navigate = useNavigate();

  // API calls
  const { data: companies, isLoading: isCompanyLoading } = useGetAllCompaniesQuery();
  const { data: pointOfSale, isLoading: isPointOfSaleLoading } = useGetAPieceOfPointOfSaleQuery(String(pointOfSaleId));
  const [ updatePointOfSale, { data: UpdatedPointOfSaleData, isSuccess: isUpdatedPointOfSaleSuccess, error: apiError } ] = useUpdatePointOfSaleMutation();
  const {data: provinces, isLoading: isProvincesLoading} = useGetAllProvincesQuery();


  // UseEffect to manage update success

  useEffect(() => {
    if (isUpdatedPointOfSaleSuccess && UpdatedPointOfSaleData) {
      toast.success(UPDATE_SUCCESS);
      navigate(RETURN_PAGE);
    }
  }, [isUpdatedPointOfSaleSuccess, UpdatedPointOfSaleData, navigate]);

  // Function to update news with form results

  const updatePointOfSaleHandler = (formData: FormData) => {
    updatePointOfSale({ id: String(pointOfSaleId), pointOfSaleToUpdate: formData });
  };

  const groupSelectOptions: ISelectOption[] = useMemo(() => {

    if (!companies||!companies) return [];

    return companies.map((company: ICompany) => ({
      label: company.name,
      value: company._id,
    }));
    
  }, [companies])

  const provinceSelectOptions: ISelectOption[] = useMemo(() => {
      
    if (!provinces) return [];    
     return provinces.map((province) => ({
      label: province.name,
      value: province._id,
    }));
  }, [provinces])

  if (isPointOfSaleLoading ||isCompanyLoading||isProvincesLoading) return <FullScreenLoader />;

  return (
    <>
      <PageTitle
        pageTitle={PAGE_TITLE}
        returnPage={RETURN_PAGE}
        returnLabel={RETURN_LABEL}
      />
      <PointOfSale.Form
        provinces={provinceSelectOptions}
        companies={groupSelectOptions}
        onSubmit={updatePointOfSaleHandler}
        currentPointOfSale={pointOfSale}
        apiError={apiError}
      />
    </>
  );
};
